import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rdsPopoverAriaLabel',
})
export class RdsPopoverAriaLabelPipe implements PipeTransform {
  /**
   * @param label The thing the popover is about, i.e. "Open measure popover", where "measure" is the `label`
   * @param open Whether this is the "Open" label, otherwise it will be "Close"...
   * @returns An aria-label for the mtna-popover
   */
  transform(label: string | null | undefined, open: boolean) {
    const _label = label || '';
    return open ? $localize`Open ${_label} popover` : $localize`Close ${_label} popover`;
  }
}

@NgModule({
  declarations: [RdsPopoverAriaLabelPipe],
  exports: [RdsPopoverAriaLabelPipe],
})
export class RdsPopoverAriaLabelPipeModule {}
